import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './composants/app';
import reportWebVitals from './reportWebVitals';
import { store } from './composants/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// ===== SUPPRESS RESIZEOBSERVER OVERLAY ERRORS =====
// Suppress ResizeObserver loop completed with undelivered notifications error in development
window.addEventListener('error', (e) => {
  if (e.message && (e.message.includes('ResizeObserver') || e.message.includes('resize observer'))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && (e.reason.message.includes('ResizeObserver') || e.reason.message.includes('resize observer'))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
// ===== END SUPPRESSION =====

// ===== STORAGE CLEANUP (runs before React mounts) =====
// This permanently fixes QuotaExceededError caused by old large base64 images
// stored in localStorage from previous app versions.
try {
  const userStr = localStorage.getItem('user');
  if (userStr && userStr.length > 50000) {
    // User object is huge — strip the oversized profilePic before anything renders
    const user = JSON.parse(userStr);
    localStorage.removeItem('user');
    localStorage.setItem('user', JSON.stringify({
      id: user.id,
      name: user.name,
      email: user.email,
      role: user.role,
      isGoogle: user.isGoogle,
      profilePic: null
    }));
  }
} catch (e) {
  // localStorage is completely corrupted — wipe everything
  localStorage.clear();
}
// ===== END CLEANUP =====

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
